import * as React from 'react';
import * as styles from './modal.module.scss';
import { Modal, IconButton } from '@material-ui/core';
import { Close } from '@material-ui/icons';
import clsx from 'clsx';

interface Props {
  isOpen: boolean;
  onClose: (open: boolean, option?: any) => void;
  title: string;
  subtitle?: string;
  status?: string;
  children: React.ReactNode;
  width: string;
}

/**
 * ModalDialog
 * @function ModalDialog - Base modal with header and close icon button
 */
const ModalDialog = ({ isOpen, onClose, subtitle, title, status, children, width }: Props) => {
  return (
    <Modal
      className={styles.modal}
      style={{ width }}
      open={isOpen}
      onClose={(isOpen: boolean, option?: any) => onClose(!isOpen, option)}
    >
      <div className={styles.container}>
        <IconButton onClick={() => onClose(!isOpen, null)} size="small" className={styles.exitButton}>
          <Close />
        </IconButton>
        <div className={styles.header}>
          <div className={styles.title}>
            <p className={styles.subtitle}>{subtitle}</p>
            <p className={clsx(styles.mainTitle, !subtitle && styles.withoutSubtitle)}>{title}</p>
          </div>
          {status && (
            <p className={styles.status}>
              <span className="label1">Status:</span> <span className="body1">{status}</span>
            </p>
          )}
        </div>
        <div className={styles.content}>{children}</div>
      </div>
    </Modal>
  );
};

export default ModalDialog;
